import React, { ReactNode } from 'react';
import { useBlocker } from 'react-router-dom'; // React Router hooks
import { Modal } from '../components';
import { Button } from '../components/primitives';
import { useSaveBar } from '../hooks/useSaveBar';




export const SaveBarBlocker: React.FC<{ children: ReactNode }> = ({ children }) => {

    const saveBar = useSaveBar();

    // Intercept navigation
    const blocker = useBlocker(
        ({ currentLocation, nextLocation }) =>
            saveBar.isActive && currentLocation.pathname !== nextLocation.pathname
    );
    // setShowLeaveModal(blocker.state === 'blocked');

    const confirmLeave = () => {
        if(blocker.state === 'blocked') {
            saveBar.discardAction && saveBar.discardAction.onAction();
            blocker.proceed();
        }
    };

    const cancelLeave = () => {
        blocker.state === 'blocked' && blocker.reset();

    };

    return (
        <>
            <Modal
                title="Unsaved Changes"
                open={blocker.state === 'blocked'}
                onClose={cancelLeave}
            >
                <p>You have unsaved changes. Are you sure you want to leave?</p>
                <div className="flex justify-end space-x-4">
                    <Button variant="outline" onClick={cancelLeave}>
                        Stay
                    </Button>
                    <Button variant="primary" onClick={confirmLeave}>
                        Leave
                    </Button>
                </div>
            </Modal>
            {children}
        </>


    );
};
